export const API_URL = "https://www.pv.slgrd.com/api"